import { Amplify } from 'aws-amplify';

import {
  APP_BASE_URI,
  AUTH_BASE_URL,
  AUTH_CLIENT_ID,
  AUTH_COGNITO_IDENTITY_POOL_ID,
  AUTH_REGION,
  AUTH_RESPONSE_TYPE,
  AUTH_SIGN_OUT_URL,
  AUTH_USER_POOL_ID,
  LOCATION_PLACE_INDEX,
  OAUTH_SCOPES,
} from './constants';

export const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: String(AUTH_USER_POOL_ID),
        userPoolClientId: String(AUTH_CLIENT_ID),
        identityPoolId: AUTH_COGNITO_IDENTITY_POOL_ID,
        loginWith: {
          oauth: {
            domain: (AUTH_BASE_URL || '').replace('https://', ''),
            scopes: [...OAUTH_SCOPES],
            // Must exist in Allowed login URLs in Cognito
            // If not, leads to error: "missing param redirect_uri"
            redirectSignIn: [String(APP_BASE_URI)],
            // Must exist in Allowed logout URLs in Cognito
            // If not, leads to error: "missing param redirect_uri"
            redirectSignOut: [String(AUTH_SIGN_OUT_URL)],
            responseType: AUTH_RESPONSE_TYPE as 'code' | 'token',
          },
        },
      },
    },
    Geo: {
      LocationService: {
        region: String(AUTH_REGION),
        searchIndices: {
          items: [LOCATION_PLACE_INDEX],
          default: LOCATION_PLACE_INDEX,
        },
      },
    },
  });
};
